//This a wrapper for common functions that will run if the page transition add on is enabled or not.
function commonFunctionsWrapper() {
	wrappeTextFields();
	addAddressClass();
	enhanceCustomDropdown('.block-quiz-survey .custom-state');
	enhanceCustomDropdown('.block-quiz-survey .hear-about-us');
	populateDropdown();
	insertCustomDescriptionBox();
	centerNextBtn();
}

//This event will work if gravity form page transition plugin is disabled.
document.addEventListener('DOMContentLoaded', function () {
	const slider = document.querySelector(
		'.block-quiz-survey .goal_weight .nurslider'
	);
	const input = document.querySelector(
		'.block-quiz-survey .current_weight input'
	);

	if (slider) {
		slider.addEventListener('input', addGoalWeight);
	}
	if (input) {
		input.addEventListener('input', addGoalWeight);
	}

	if (window.jQuery) {
		window.jQuery(document).on('gform_page_loaded', function () {
			commonFunctionsWrapper();
			addGoalWeight();
			addBackButton();
			setMaxFormBodyHeight();
		});
		addBackButton();
		centerNextBtn();
	}
});

window.addEventListener('resize', () => {
	window.requestAnimationFrame(centerNextBtn);
});

//This event will work if gravity form page transition plugin is enabled.
gform.addFilter('gppt_swiper_options', function (options) { // eslint-disable-line
	options.on.init = function () {
		commonFunctionsWrapper();
	};
	options.on.slideChange = function () {
		addGoalWeight();
		centerNextBtn();
	};

	return options;
});

// Function to check state field and add message on the base of specific state is changed
document.addEventListener('change', function (event) {
	const stateField = document.querySelector(
		'.block-quiz-survey .custom-state select'
	);
	if (!stateField) return;

	const customStateField = document.querySelector(
		'.block-quiz-survey .custom-state .custom-dropdown'
	);
	if (event.target === stateField) {
		let messageElement = document.getElementById('state-message');
		if (!messageElement) {
			messageElement = document.createElement('p');
			messageElement.id = 'state-message';
			customStateField.parentNode.insertBefore(
				messageElement,
				customStateField.nextSibling
			);
		}

		const specificStates = [
			'Arizona',
			'Illinois',
			'Michigan',
			'Ohio',
			'Florida',
			'Georgia',
			'Indiana',
			'North Carolina',
			'Pennsylvania',
			'Virginia',
		];

		const selectedState = stateField.value.trim();
		let message = '';

		stateField.classList.remove('covered-state', 'uncovered-state');
		messageElement.classList.remove(
			'covered-state-message',
			'uncovered-state-message'
		);

		if (specificStates.includes(selectedState)) {
			const messageSuccess = document
				.querySelector('.block-quiz-survey')
				.getAttribute('data-state-success');
			if (messageSuccess) {
				message = messageSuccess;
			} else {
				message =
					'*Great! We have coverage in your area. Share your ZIP code below for us to match you with the closest location.';
			}
			stateField.classList.add('covered-state');
			messageElement.classList.add('covered-state-message');
		} else if (selectedState) {
			const messageFailed = document
				.querySelector('.block-quiz-survey')
				.getAttribute('data-state-failed');
			if (messageFailed) {
				message = messageFailed;
			} else {
				message =
					'*We don’t currently offer coverage in your state. Sign up here for updates as more locations become available.';
			}
			stateField.classList.add('uncovered-state');
			messageElement.classList.add('uncovered-state-message');
		} else {
			message = '';
		}

		messageElement.textContent = message;
	}
});

//Function to add wrapper for different fields to add max width
function wrappeTextFields() {
	document
		.querySelectorAll('.block-quiz-survey .gform_page_fields')
		.forEach(function (page) {
			let groupContainer = null;

			page.querySelectorAll('.gfield').forEach(function (field) {
				if (
					field.classList.contains('gfield--type-text') ||
					field.classList.contains('gfield--type-email') ||
					field.classList.contains('gfield--type-phone') ||
					field.classList.contains('gfield--type-number') ||
					field.classList.contains('gfield--type-select')
				) {
					if (!groupContainer) {
						groupContainer = document.createElement('div');
						groupContainer.classList.add('custom-text-wrapper');
						field.parentNode.insertBefore(groupContainer, field);
					}
					groupContainer.appendChild(field);
				} else {
					groupContainer = null;
				}
			});
		});
}

//Function to add back button on first step of gravity form
function addBackButton() {
	const firstStepDiv = document.querySelector(
		'.block-quiz-survey .gform-body .gform_page:first-child'
	);

	if (firstStepDiv) {
		const formWrapper = document.querySelector(
			'.block-quiz-survey .gform_wrapper'
		);

		if (formWrapper) {
			const pageFooter = firstStepDiv.querySelector('.gform-page-footer');

			if (
				pageFooter &&
				!pageFooter.querySelector('.gform_previous_button')
			) {
				const backButton = document.createElement('a');
				backButton.className =
					'gform_button c-btn c-btn--primary custom-back-btn';
				backButton.textContent = 'Back';
				backButton.onclick = function () {
					window.location.href = '/get-started/';
				};
				pageFooter.insertBefore(backButton, pageFooter.firstChild);
			}
		}
	}
}

//Function to add class to address field
function addAddressClass() {
	document
		.querySelectorAll('.block-quiz-survey .gform_page')
		.forEach(function (page) {
			if (
				page.querySelector('.block-quiz-survey .gfield--type-address')
			) {
				page.classList.add('has-address-field');
			}
		});
}

//Function to add goal weight and current weight to URL and make the calculation
function addGoalWeight() {
	const goalWeightInput = document.querySelector(
		'.block-quiz-survey .goal_weight .nurslider'
	);
	const currentWeightInput = document.querySelector(
		'.block-quiz-survey .current_weight input'
	);

	if (
		goalWeightInput &&
		currentWeightInput &&
		goalWeightInput.value &&
		currentWeightInput.value
	) {
		const goalWeight = parseFloat(goalWeightInput.value);
		const currentWeight = parseFloat(currentWeightInput.value);
		const parentStep = currentWeightInput.closest('.gform_page');
		const nextButton = parentStep?.querySelector('.gform_next_button');

		if (currentWeight <= goalWeight) {
			if (parentStep) parentStep.classList.add('invalid-goal-step');
			if (nextButton) nextButton.disabled = true;
		} else {
			if (parentStep) parentStep.classList.remove('invalid-goal-step');
			if (nextButton) nextButton.disabled = false;
		}

		const url = new URL(window.location.href);
		url.searchParams.set('goal_weight', goalWeightInput.value);
		url.searchParams.set('current_weight', currentWeightInput.value);
		window.history.pushState({}, '', url.toString());

		const targetWeight = currentWeight - goalWeight;
		const targetWeightSpan = document.querySelector('.target-weight-text');
		if (targetWeightSpan) {
			targetWeightSpan.textContent = targetWeight.toFixed(1);
		}
	}
}

// Function to create custom dropdown for location and fetch locations from locations post type
function populateDropdown() {
	const stateDropdown = document.querySelector(
		'.block-quiz-survey .custom-state select'
	);
	const locationDropdown = document.querySelector(
		'.block-quiz-survey .custom-location select'
	);

	if (!stateDropdown || !locationDropdown || !window.location_data) return;

	function updateLocationOptions() {
		const selectedState = stateDropdown.value
			.trim()
			.toLowerCase()
			.replace(/\s+/g, '-');
		const locationData = window.location_data;
		const currentLocationValue =
			sessionStorage.getItem('selectedLocation') || '';

		locationDropdown.innerHTML =
			'<option value="">Select a location</option>';

		if (locationData[selectedState]) {
			locationData[selectedState].forEach((location) => {
				const opt = document.createElement('option');
				opt.value = String(location.title);
				opt.textContent = location.title;

				if (String(location.title) === currentLocationValue) {
					opt.selected = true;
				}

				locationDropdown.appendChild(opt);
			});
		}

		createCustomLocationDropdown();
	}

	function createCustomLocationDropdown() {
		const wrapper = document.querySelector('.custom-location');
		if (!wrapper) return;
		const existing = wrapper.querySelector('.custom-dropdown');
		if (existing) existing.remove();

		const customDropdown = document.createElement('div');
		customDropdown.className = 'custom-dropdown';

		const selected = document.createElement('div');
		selected.className = 'custom-selected';
		const selectedOption =
			locationDropdown.options[locationDropdown.selectedIndex];
		selected.textContent = selectedOption
			? selectedOption.textContent
			: 'Select a location';
		if (locationDropdown.value) {
			selected.classList.add('active');
		}

		customDropdown.appendChild(selected);

		const optionsContainer = document.createElement('div');
		optionsContainer.className = 'custom-options-list';
		optionsContainer.style.display = 'none';

		[...locationDropdown.options].forEach((option) => {
			if (!option.value) return;

			const opt = document.createElement('div');
			opt.className = 'custom-option';
			opt.textContent = option.textContent;

			if (option.selected) opt.classList.add('selected');

			opt.addEventListener('click', () => {
				locationDropdown.value = option.value;
				locationDropdown.dispatchEvent(new Event('change'));
				sessionStorage.setItem('selectedLocation', option.value);

				selected.textContent = option.textContent;

				optionsContainer
					.querySelectorAll('.custom-option')
					.forEach((o) => o.classList.remove('selected'));
				opt.classList.add('selected');
				optionsContainer.style.display = 'none';

				customDropdown.classList.remove('active');
				if (option.value) {
					selected.classList.add('active');
				} else {
					selected.classList.remove('active');
				}
			});

			optionsContainer.appendChild(opt);
		});

		customDropdown.appendChild(optionsContainer);
		wrapper.appendChild(customDropdown);

		selected.addEventListener('click', (e) => {
			e.stopPropagation();
			const isOpen = optionsContainer.style.display === 'block';
			optionsContainer.style.display = isOpen ? 'none' : 'block';
			customDropdown.classList.toggle('active', !isOpen);
		});

		document.addEventListener('click', (e) => {
			if (!customDropdown.contains(e.target)) {
				optionsContainer.style.display = 'none';
				customDropdown.classList.remove('active');
			}
		});
	}

	updateLocationOptions();
	stateDropdown.addEventListener('change', updateLocationOptions);
}

// Function to create custom dropdown for state
function enhanceCustomDropdown(wrapperSelector) {
	const wrapper = document.querySelector(wrapperSelector);
	if (!wrapper) return;

	// Prevent duplicate enhancement
	if (wrapper.querySelector('.custom-dropdown')) return;

	const select = wrapper.querySelector('select');
	if (!select) return;

	const customDropdown = document.createElement('div');
	customDropdown.className = 'custom-dropdown';

	const selectedOption = document.createElement('div');
	selectedOption.className = 'selected-option';
	selectedOption.textContent = select.options[select.selectedIndex]?.text;

	if (select.value) {
		selectedOption.classList.add('active');
	}

	const optionsList = document.createElement('div');
	optionsList.className = 'options-list';
	optionsList.style.display = 'none';

	const optionsFade = document.createElement('div');
	optionsFade.className = 'options-fade';
	optionsFade.style.bottom = '0';
	optionsFade.style.opacity = '1';

	[...select.options].forEach((option) => {
		const optDiv = document.createElement('div');
		optDiv.className = 'option';
		optDiv.textContent = option.textContent;

		if (option.selected) {
			optDiv.classList.add('active');
		}

		optDiv.addEventListener('click', () => {
			selectedOption.textContent = option.textContent;

			optionsList
				.querySelectorAll('.option')
				.forEach((opt) => opt.classList.remove('active'));
			optDiv.classList.add('active');

			[...select.options].forEach((opt) => {
				opt.selected = opt.value === option.value;
			});
			select.dispatchEvent(new Event('change', { bubbles: true }));

			optionsList.style.display = 'none';
			customDropdown.classList.remove('active');
			if (option.value) {
				selectedOption.classList.add('active');
			} else {
				selectedOption.classList.remove('active');
			}
		});

		optionsList.appendChild(optDiv);
	});

	selectedOption.addEventListener('click', () => {
		const isOpen = optionsList.style.display === 'block';
		optionsList.style.display = isOpen ? 'none' : 'block';
		customDropdown.classList.toggle('active', !isOpen);
	});

	document.addEventListener('click', (e) => {
		if (!customDropdown.contains(e.target)) {
			optionsList.style.display = 'none';
			customDropdown.classList.remove('active');
		}
	});

	optionsList.addEventListener('scroll', () => {
		const scrollTop = optionsList.scrollTop;
		optionsFade.style.transform = `translateY(${scrollTop}px)`;
	});

	optionsList.appendChild(optionsFade);
	customDropdown.appendChild(selectedOption);
	customDropdown.appendChild(optionsList);
	wrapper.appendChild(customDropdown);
}

// Add custom text in 2nd step of the form
function insertCustomDescriptionBox() {
	const fieldsets = document.querySelectorAll(
		'.block-quiz-survey fieldset.custom-description'
	);

	fieldsets.forEach((fieldset) => {
		const legend = fieldset.querySelector('legend');
		if (!legend) return;
		if (fieldset.querySelector('.custom-description-box')) return;

		const descBox = document.createElement('div');
		descBox.className = 'custom-description-box';
		descBox.textContent = 'Select all that apply:';

		legend.insertAdjacentElement('afterend', descBox);
	});
}

// Function to check max height from each step and set that height as wrapper height
function setMaxFormBodyHeight() {
	const steps = document.querySelectorAll('.block-quiz-survey .gform_page');
	const formBody = document.querySelector(
		'.block-quiz-survey .gform_wrapper'
	);

	if (!steps.length || !formBody) return;

	let maxHeight = 0;

	steps.forEach((step) => {
		const originalDisplay = step.style.display;
		step.style.display = 'block';

		const stepHeight = step.offsetHeight;
		if (stepHeight > maxHeight) {
			maxHeight = stepHeight;
		}
		step.style.display = originalDisplay;
	});

	formBody.style.height = `${maxHeight + 50}px`;
}

// Function to center next button
function centerNextBtn() {
	const footers = document.querySelectorAll('.gform_page_footer');

	footers.forEach((footer) => {
		const nextBtn = footer.querySelector('.gform_next_button');
		const backBtn =
			footer.querySelector('.gform_previous_button') ||
			footer.querySelector('.custom-back-btn');

		if (!nextBtn || !backBtn) return;

		const containerWidth = footer.offsetWidth;
		const nextBtnWidth = nextBtn.offsetWidth;
		const backBtnWidth = backBtn.offsetWidth;
		const targetLeft = containerWidth / 2 - nextBtnWidth / 2 - backBtnWidth;

		backBtn.style.marginRight = `${targetLeft}px`;
	});
}

window.gform.addFilter(
	'gppt_validation_result',
	function (result, gppt, formId) {
		if (formId !== 14) return result;

		const currentPage = gppt.currentPage;

		if (currentPage === 6) {
			const emailField = document.querySelector('#input_14_58');

			if (!emailField) {
				return false;
			}

			const value = emailField.value.trim();
			const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);

			const gfield = emailField.closest('.gfield');

			if (!isValid) {
				if (gfield) {
					gfield.classList.add('gfield_error');

					// Remove existing validation message
					const existingMsg = gfield.querySelector(
						'.validation_message'
					);
					if (existingMsg) existingMsg.remove();

					// Create a new validation message
					const errorMessage = document.createElement('div');
					errorMessage.className =
						'gfield_description validation_message';
					errorMessage.innerText =
						'The email address entered is invalid, please check the formatting (e.g. email@domain.com).';
					gfield
						.querySelector('.ginput_container')
						.after(errorMessage);
				}
				return false; // Block the page transition
			}
			// Clear error state if fixed
			if (gfield) {
				gfield.classList.remove('gfield_error');
				const existingMsg = gfield.querySelector('.validation_message');
				if (existingMsg) existingMsg.remove();
			}
		}
		if (result !== false) {
			setTimeout(function () {
				// Smooth scroll to top (header)
				window.scrollTo({
					top: 0,
					behavior: 'smooth',
				});
			}, 500);
		}

		return result;
	}
);
